import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import {
	Emoji,
	Picker
} from 'emoji-mart-vue';

import vSelect from 'vue-select';

import toastr from '@/support/toastr';
import SchoolClassList from '@/domains/school/class-list/main';
import Students from '@/domains/student/students';

import i18nEmoji from '@/i18n/i18n-emoji.json';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'message-new',
	data: () => ({
		selected: null,
		responsible: [],
		member: [],
		subject: '',
		message: '',
		emojiPickerVisible: false,
		i18n: i18nEmoji['pt_BR']
	}),
	components: {
		Emoji,
		Picker,
		vSelect,
		SchoolClassList,
		Students
	},
	computed: {
		...mapState({
			studentName: (state) => state.Student.selected.name,
			className: (state) => state.Class.selected.description,
			recipient: (state) => state.Inbox.list,
			studentId: (state) => state.Student.selected.studentId,
			userId: (state) => state.Logged.user.id
		}),
		...mapGetters({
			responsibles: 'getInboxResponsibles',
			schoolmembers: 'getInboxSchoolMembers'
		})
	},

	methods: {
		...mapActions([
			'getMessageRecipient',
			'sendMessageNew',
			'putMessageSubject',
			'putMessageMessage',
			'putMessageRecipientSelected',
			'setRecipients',
			'getMessageGroup'
		]),
		insertAtCaret(text, element = 'textarea') {

			// https://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery#answer-28353499

			let textarea = document.querySelector(element);
			let caretPosition = textarea.selectionStart;
			let front = (textarea.value).substring(0, caretPosition);
			let back = (textarea.value).substring(textarea.selectionEnd, textarea.value.length);

			this.message = front + text + back;

		},
		addEmoji(emoji) {
			this.insertAtCaret(emoji.native);
		},
		sendNewMessage() {

			let usersArray = [];

			this.responsible.forEach((user) => {

				usersArray.push({
					user: {
						userId: user.userId
					}
				});

			});

			this.member.forEach((user) => {

				usersArray.push({
					user: {
						userId: user.userId
					}
				});

			});

			this.sendMessageNew({
				from: {
					userId: this.userId
				},
				student: {
					studentId: this.studentId
				},
				subject: this.subject,
				message: this.message,
				users: usersArray
			}).then((response) => {

				this.getMessageGroup(response.data.messageGroup);

				this.$router.push({
					name: 'ReplyMessage',
					params: {
						id: response.data.messageGroup
					}
				});

				toastr.success('Mensagem enviada com sucesso!');

			});

		}
	},
	mounted() {

		EventBus.$on('setStudent', () => {

			this.responsible = [];
			this.schoolmembers = [];

		});

	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};


// WEBPACK FOOTER //
// ./sources/domains/inbox/message-new/index.js